module.exports = __webpack_public_path__ + "static/media/CaitlinO'Callaghan_Resume_Oct_4_2021.6291610a.pdf";